export default "__VITE_ASSET__Dq307BCU__"